import { If } from "lib/@components/switch"
import { Box, Stack } from "@mui/material"
import { JustificationDisplay } from "./justification-display"
import { Bound } from "lib/@components/binding/Bound"

export function JustificationReason({ payload, userName, date }) {
    return (
        <If truthy={!!payload?.reason}>
            <Bound createdOn={date} createdBy={userName} allowEdit={false}>
                <Box
                    sx={{
                        p: 1.5,
                        bgcolor: "background.neutral",
                        borderRadius: 1,
                        wordBreak: "break-word",
                    }}
                >
                    <Stack spacing={1}>
                        <JustificationDisplay payload={payload} />
                    </Stack>
                </Box>
            </Bound>
        </If>
    )
}
